/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      if ( $( '.before-and-after-slider' ).length ) {
        $( '.before-and-after-slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            pagination: false,
            arrows: true,
            speed: 800,
            perPage: 1,
            gap: '2rem',
          } );
          slider.mount();
        } );

        const liveRegion = $( '.ba-slider__live-region' );

        $( '.ba-slider__toggle' ).on( 'toggleAfter', ( event ) => {
          const target = $( event.target );
          if ( target.attr( 'aria-pressed' ) ) {
            target.attr( 'aria-pressed', false );
            liveRegion.text( 'Sensitive images are visible' );
          } else {
            liveRegion.text( 'Sensitive images are blurred' );
            target.attr( 'aria-press', true );
          }
        } );

        // Function to update button classes based on screen width
        const updateButtonClasses = () => {
          if ( window.innerWidth >= 1024 ) {
            $( '.before-and-after-slider .wysiwyg .btn-primary' ).not( '.btn-primary-light' ).addClass( 'btn-primary-light' );
            $( '.before-and-after-slider .wysiwyg .btn-secondary' ).not( '.btn-secondary-light' ).addClass( 'btn-secondary-light' );
          } else {
            $( '.before-and-after-slider .wysiwyg .btn-primary.btn-primary-light' ).removeClass( 'btn-primary-light' );
            $( '.before-and-after-slider .wysiwyg .btn-secondary.btn-secondary-light' ).removeClass( 'btn-secondary-light' );
          }
        };

        // Run on initial load
        updateButtonClasses();

        // Add resize event listener
        $( window ).on( 'resize', updateButtonClasses );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
